import { PlanEstudioI } from "interfaces/PlanEstudio";
import { ValidezNacionalI } from "interfaces/ValidezNacionalI";
import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { formatDate } from "utils/formatUtils";

interface Props {
  onClose?: any;
  elemento: ValidezNacionalI | null;
  showModal: boolean;
}

export const ValidacionNacionalDetailModal = ({
  elemento,
  showModal,
  onClose,
}: Props) => {
  const [fullElement, setFullElement] = useState<ValidezNacionalI>();
  const [isLoading, setIsLoading] = useState(false);

  const getFullElement = () => {
    try {
    } catch (err) {}
  };

  useEffect(() => {
    if (showModal) {
    }
  }, [showModal]);

  return (
    <>
      <Modal show={showModal} onHide={onClose} size="lg" centered>
        <Modal.Header>
          <Modal.Title>{"Detalle Validez Nacional:"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Col>
            <Row>
              <Col lg={12} className="mb-4">
                <b>Estado:</b> <br></br>
                {elemento?.estado?.nombre}
              </Col>

              <Col sm={6} lg={6} className="mb-4">
                <b>Fecha de aprobación:</b> <br></br>
                {elemento?.fechaAprobacion &&
                  formatDate.stringDate(elemento?.fechaAprobacion)}
              </Col>

              <Col sm={6} lg={6} className="mb-4">
                <b>Fecha de caducidad:</b> <br></br>
                {elemento?.fechaCaducidad &&
                  formatDate.stringDate(elemento?.fechaCaducidad)}
              </Col>

              <hr></hr>

              <Col sm={6} className="mb-4">
                <b>N° de expediente interno:</b> <br></br>
                {elemento?.expedienteInterno
                  ? elemento?.expedienteInterno
                  : "Sin Asignar"}
              </Col>

              <Col sm={6} className="mb-4">
                <b>N° de expediente Nacional:</b> <br></br>
                {elemento?.expedienteNacional
                  ? elemento?.expedienteNacional
                  : "Sin Asignar"}
              </Col>

              <Col sm={6} className="mb-4">
                <b>Normativa:</b> <br></br>
                {elemento?.normativa
                  ? elemento?.normativa.nombre
                  : "Sin Asignar"}
              </Col>

              <Col sm={6} className="mb-4">
                <b>Plan de estudio:</b> <br></br>
                {elemento?.planEstudio
                  ? elemento?.planEstudio.nombre
                  : "Sin Asignar"}
              </Col>
            </Row>
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="mx-3"
            variant="secondary"
            size="lg"
            onClick={onClose}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
